
import * as _ from 'underscore'

import { TypeHelper } from '../../../helpers'


// Public Types

export interface IIMROverlayContainer {
    showText(text: string): void
    hide(): void
}

export type IMROverlayContainerOptions = {
    onInitialized?(component: IIMROverlayContainer): void
}

// Public Types End


export class IMROverlayContainerController implements ng.IComponentController, IIMROverlayContainer {

    // Members

    private options: IMROverlayContainerOptions

    private isOverlayVisible: boolean
    private overlayText: string

    // Members End


    // IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // IComponentController Implementation End


    // IIMROverlayContainer Implementation

    public hide(): void {
        this.isOverlayVisible = false
        this.overlayText = TypeHelper.emptyString
    }

    public showText(text: string): void {
        this.isOverlayVisible = true
        this.overlayText = text
    }

    // IIMROverlayContainer Implementation End


    // Component

    private initialize(): void {
        this.setDefaults()
        this.onInitialized()
    }

    // Component End


    // Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    // Events End


    // Options

    private setDefaults(): void {
        this.isOverlayVisible = false
        this.overlayText = TypeHelper.emptyString
    }

    // Options End
}
